import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SewPicture } from '@sew/ui-components-angular/standalone';
import { Content } from '../../../../models/blog-posts.model';
@Component({
    selector: 'blog-picture',
    templateUrl: './picture.component.html',
    styleUrls: ['./picture.component.scss'],
    imports: [CommonModule, SewPicture],
})
export class PictureComponent {
    @Input() public picture?: Content;
    @Input() public noCaption = false;
}
